module.exports = __webpack_public_path__ + "img/Mexico.2b049d16.png";